import React from 'react';

import NotificationIcon from '../../icons/NotificationIcon';

import IconBadge from './IconBadge';

const NotificationBadge = ({ numUnread = 0 }) => (
  <IconBadge bgColor="red-500" fontColor="white" icon={<NotificationIcon />}>
    {numUnread}
  </IconBadge>
);

export default NotificationBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/NotificationBadge.js